import { render, staticRenderFns } from "./fodera-fits.vue?vue&type=template&id=5502f1b0&"
import script from "./fodera-fits.vue?vue&type=script&lang=js&"
export * from "./fodera-fits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports